import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Tooltip, Dialog, useMediaQuery, Button } from "@mui/material";
import { Facebook, Twitter, Instagram, LinkedIn, YouTube, WhatsApp, Language } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Header from "./Header";
import CategoryTabs from "./CategoryTabs";
import ProductGrid from "./ProductGrid";
import CartDrawer from "./CartDrawer";
import SearchBar from "./SearchBar";
import SearchResults from "./SearchResults";
import ProductDetailsModal from "./ProductDetailsModal";
import OnlineOffers from "./OnlineOffers";
import { getMenusPublic, getPublicData, getOffersPublicAll } from "../../../services/publicPegasApi/MakePublicOrder";
import { fetchSocialMediaLinks } from "../../../services/dashboard/SocialMediaLinksApi";

const CustomerMenu = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [cart, setCart] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [publicData, setPublicData] = useState(null);
  const [showSplash, setShowSplash] = useState(true);
  const [socialLinks, setSocialLinks] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [offersOpen, setOffersOpen] = useState(false);
  const [hasOffers, setHasOffers] = useState(false);

  const subdomain = window.location.hostname.split(".")[0];
  const IMAGE_BASE_URL = subdomain ? `https://${subdomain}.restocash.app/` : "";
  const placeholderFooter = "https://via.placeholder.com/1200x200?text=Footer+Image";

  const getImageUrl = (path, placeholder) => {
    if (!path) return placeholder;
    if (typeof path === "string" && (path.startsWith("http://") || path.startsWith("https://"))) {
      return path;
    }
    const cleanPath = String(path).replace(/^\/+/, "");
    return IMAGE_BASE_URL ? `${IMAGE_BASE_URL.replace(/\/+$/, "")}/${cleanPath}` : placeholder;
  };

const footerImage = getImageUrl(publicData?.footer_image, placeholderFooter);
const bannerImage = getImageUrl(publicData?.banner_image, null);


  // استخراج بيانات الاتصال من الهيكل المتداخل publicData.data.data
  const contactPhone = publicData?.data?.data?.phone || publicData?.phone || null;
  const contactAddress = publicData?.data?.data?.address || publicData?.address || null;

  useEffect(() => {
    const fetchMenus = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getMenusPublic();
        setMenus(Array.isArray(data) ? data : data.data || []);
      } catch (err) {
        setError("فشل في جلب القوائم");
        
      } finally {
        setLoading(false);
      }
    };
    fetchMenus();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await getPublicData();
  //       console.log("🔥 بيانات الهيدر والفوتر:", data);
  //       setPublicData(data);
  //     } catch (err) {
  //       console.error("فشل في جلب بيانات الهيدر والفوتر:", err);
  //     }
  //   };
  //   fetchData();
  // }, []);
  useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await getPublicData();
      const extracted = res?.data?.data ?? res?.data ?? res;  // ✅ normalize
      console.log("🔥 PublicData extracted:", extracted);
      setPublicData(extracted);
    } catch (err) {
      console.error("فشل في جلب بيانات الهيدر والفوتر:", err);
    }
  };
  fetchData();
}, []);

  // جلب روابط وسائل التواصل الاجتماعي
  useEffect(() => {
    const fetchSocial = async () => {
      try {
        const response = await fetchSocialMediaLinks();
        const links = response?.data?.data || [];
        // فلترة الروابط النشطة فقط
        const activeLinks = links.filter(link => link.status === "active");
        setSocialLinks(activeLinks);
      } catch (err) {
        console.error("فشل في جلب روابط وسائل التواصل:", err);
      }
    };
    fetchSocial();
  }, []);

  // جلب العروض للتحقق من وجودها
  useEffect(() => {
    const checkOffers = async () => {
      try {
        const res = await getOffersPublicAll();
        const list = res?.data ?? res;
        const offers = Array.isArray(list) ? list : [];
        setHasOffers(offers.length > 0);
      } catch (err) {
        console.error("فشل في جلب العروض:", err);
        setHasOffers(false);
      }
    };
    checkOffers();
  }, []);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setShowSplash(false), 1200);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  const handleAddToCart = (product) => {
    setSelectedProduct(product);
    setProductModalOpen(true);
  };

  const handleConfirmProduct = (productWithDetails) => {
    setCart((prev) => [...prev, productWithDetails]);
    setProductModalOpen(false);
    setSelectedProduct(null);
  };

  const handleOrderSuccess = () => {
    setCart([]);
  };

  const selectedCategory = menus[tabIndex];
  const branch = menus[0]?.root;

  // دالة للحصول على أيقونة حسب النوع
  const getSocialIcon = (type) => {
    const iconProps = { sx: { fontSize: { xs: 28, sm: 32 } } };
    
    switch (type?.toLowerCase()) {
      case "facebook":
        return <Facebook {...iconProps} />;
      case "twitter":
        return <Twitter {...iconProps} />;
      case "instagram":
        return <Instagram {...iconProps} />;
      case "linkedin":
        return <LinkedIn {...iconProps} />;
      case "youtube":
        return <YouTube {...iconProps} />;
      case "whatsapp":
        return <WhatsApp {...iconProps} />;
      default:
        return <Language {...iconProps} />;
    }
  };

  // دالة للحصول على لون الأيقونة حسب النوع
  const getSocialColor = (type) => {
    switch (type?.toLowerCase()) {
      case "facebook":
        return "#1877F2";
      case "twitter":
        return "#1DA1F2";
      case "instagram":
        return "#E4405F";
      case "linkedin":
        return "#0A66C2";
      case "youtube":
        return "#FF0000";
      case "whatsapp":
        return "#25D366";
      default:
        return "#757575";
    }
  };

  // استخراج رابط الواتساب من الروابط النشطة
  const whatsappLink = socialLinks.find(link => link.type?.toLowerCase() === "whatsapp");

  // دالة البحث في جميع المنتجات
  const getAllFilteredProducts = () => {
    if (!searchQuery.trim()) return null;

    const query = searchQuery.toLowerCase();
    const results = [];
    let totalProducts = 0;

    menus.forEach(menu => {
      const matchedProducts = menu.products.filter(product =>
        product.name?.toLowerCase().includes(query) ||
        product.description?.toLowerCase().includes(query) ||
        product.price?.toString().includes(query)
      );

      if (matchedProducts.length > 0) {
        results.push({
          category: menu.category,
          products: matchedProducts
        });
        totalProducts += matchedProducts.length;
      }
    });

    return results.length > 0 ? { categories: results, totalProducts } : null;
  };

  const searchResults = getAllFilteredProducts();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#fff",
        pb: 0,
        fontFamily: "Cairo, Arial, sans-serif",
        position: "relative",
      }}
    >
      {/* تأثير تحميل احترافي */}
      {showSplash && (
        <Box
          sx={{
            position: "fixed",
            zIndex: 2000,
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transition: "opacity 0.5s",
            opacity: showSplash ? 1 : 0,
          }}
        >
          <Box
            sx={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              bgcolor: "#fffbe6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 24px #ffb30022",
              mb: 3,
              animation: "splash-bounce 1.2s infinite",
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
              alt="logo"
              width={56}
              height={56}
              style={{ display: "block" }}
            />
          </Box>
          <Typography
            sx={{
              color: "#ffb300",
              fontWeight: 900,
              fontSize: 26,
              letterSpacing: 2,
              mb: 1,
            }}
          >
            جاري التحميل...
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 6,
              borderRadius: 3,
              bgcolor: "#ffb30022",
              overflow: "hidden",
              mt: 2,
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 6,
                bgcolor: "#ffb300",
                borderRadius: 3,
                animation: "splash-bar 1.2s infinite",
              }}
            />
          </Box>
          <style>
            {`
          @keyframes splash-bounce {
            0%, 100% { transform: translateY(0);}
            50% { transform: translateY(-18px);}
          }
          @keyframes splash-bar {
            0% { margin-left: 0; width: 30px;}
            50% { margin-left: 30px; width: 10px;}
            100% { margin-left: 0; width: 30px;}
          }
          `}
          </style>
        </Box>
      )}

      {/* Header */}
      <Header
        publicData={publicData}
        branch={branch}
        cartCount={cart.length}
        onCartOpen={() => setDrawerOpen(true)}
        getImageUrl={getImageUrl}
      />

      {/* Search Bar */}
      {!loading && !error && menus.length > 0 && (
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          searchResults={searchResults}
        />
      )}

      {/* Category Tabs - إخفاء عند البحث */}
      {!loading && !error && menus.length > 0 && !searchQuery && (
        <CategoryTabs
          menus={menus}
          tabIndex={tabIndex}
          onTabChange={setTabIndex}
          selectedCategory={selectedCategory}
          IMAGE_BASE_URL={IMAGE_BASE_URL}
        />
      )}

      {/* Loading & Error */}
      {loading && (
        <Typography align="center" sx={{ mt: 6, color: "#888" }}>
          جاري التحميل...
        </Typography>
      )}
      {error && (
        <Typography color="error" align="center" sx={{ mt: 6 }}>
          {error}
        </Typography>
      )}

      {/* Search Results or Product Grid */}
      {!loading && !error && (
        searchQuery ? (
          <SearchResults
            searchResults={searchResults}
            IMAGE_BASE_URL={IMAGE_BASE_URL}
            onAddToCart={handleAddToCart}
          />
        ) : (
          selectedCategory && (
            <ProductGrid
              products={selectedCategory.products}
              IMAGE_BASE_URL={IMAGE_BASE_URL}
              onAddToCart={handleAddToCart}
            />
          )
        )
      )}

      {/* Cart Drawer */}
      <CartDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        cart={cart}
        IMAGE_BASE_URL={IMAGE_BASE_URL}
        menus={menus}
        onOrderSuccess={handleOrderSuccess}
      />

      {/* Product Details Modal */}
      <ProductDetailsModal
        open={productModalOpen}
        onClose={() => setProductModalOpen(false)}
        product={selectedProduct}
        onConfirm={handleConfirmProduct}
        IMAGE_BASE_URL={IMAGE_BASE_URL}
      />

      {/* Footer + Contact Info */}
      {(contactPhone || contactAddress) && (
        <Box
          sx={{
            width: "100%",
            px: { xs: 2, sm: 4 },
            mt: { xs: 3, sm: 4 },
            mb: { xs: 2, sm: 3 },
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1, sm: 1.5 },
            alignItems: "center",
            textAlign: "center",
            bgcolor: "#fffbe6",
            py: { xs: 2, sm: 2.5 },
            borderRadius: { xs: 2, sm: 3 },
            boxShadow: "0 2px 8px rgba(255, 179, 0, 0.1)",
          }}
        >
          {contactPhone && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography component="span" sx={{ fontSize: { xs: 18, sm: 20 } }}>📞</Typography>
              <Typography sx={{ fontWeight: 700, color: "#333", fontSize: { xs: 13, sm: 15 } }}>
                {contactPhone}
              </Typography>
            </Box>
          )}
          {contactAddress && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography component="span" sx={{ fontSize: { xs: 18, sm: 20 } }}>📍</Typography>
              <Typography sx={{ fontWeight: 500, color: "#666", fontSize: { xs: 13, sm: 15 } }}>
                {contactAddress}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      {/* Social Media Links */}
      {socialLinks.length > 0 && (
        <Box
          sx={{
            width: "100%",
            px: { xs: 2, sm: 4 },
            mt: { xs: 2, sm: 3 },
            mb: { xs: 2, sm: 3 },
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1rem", sm: "1.1rem" },
              color: "#333",
            }}
          >
            تابعنا على
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: { xs: 1.5, sm: 2 },
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {socialLinks.map((link) => (
              <Tooltip key={link.id} title={link.name_ar} arrow>
                <IconButton
                  component="a"
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    bgcolor: `${getSocialColor(link.type)}15`,
                    color: getSocialColor(link.type),
                    width: { xs: 48, sm: 56 },
                    height: { xs: 48, sm: 56 },
                    transition: "all 0.3s ease",
                    "&:hover": {
                      bgcolor: getSocialColor(link.type),
                      color: "#fff",
                      transform: "translateY(-4px)",
                      boxShadow: `0 8px 16px ${getSocialColor(link.type)}40`,
                    },
                  }}
                >
                  {getSocialIcon(link.type)}
                </IconButton>
              </Tooltip>
            ))}
          </Box>
        </Box>
      )}

      {/* Floating WhatsApp Button */}
      {whatsappLink && (
        <Tooltip title={whatsappLink.name_ar || "واتساب"} arrow placement="left">
          <IconButton
            component="a"
            href={whatsappLink.link}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              position: "fixed",
              bottom: { xs: 20, sm: 30 },
              right: { xs: 20, sm: 30 },
              bgcolor: "#25D366",
              color: "#fff",
              width: { xs: 56, sm: 64 },
              height: { xs: 56, sm: 64 },
              boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)",
              zIndex: 1000,
              transition: "all 0.3s ease",
              animation: "whatsapp-pulse 2s infinite",
              "&:hover": {
                bgcolor: "#128C7E",
                transform: "scale(1.1)",
                boxShadow: "0 6px 28px rgba(37, 211, 102, 0.6)",
              },
            }}
          >
            <WhatsApp sx={{ fontSize: { xs: 32, sm: 36 } }} />
          </IconButton>
        </Tooltip>
      )}

      {/* Floating Offers Button (professional) */}
      {hasOffers && (
      <Box
        sx={{
          position: "fixed",
          bottom: { xs: 92, sm: 110 },
          left: { xs: 20, sm: 30 },
          zIndex: 1000,
        }}
      >
        <Button
          onClick={() => setOffersOpen(true)}
          variant="contained"
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "#fff",
            height: { xs: 56, sm: 52 },
            px: { xs: 2, sm: 3 },
            boxShadow: "0 8px 30px rgba(118,75,162,0.4)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            animation: "offers-pulse 3s ease-in-out infinite",
            borderRadius: { xs: 28, sm: 26 },
            border: "3px solid rgba(255,255,255,0.3)",
            backdropFilter: "blur(10px)",
            fontFamily: "Cairo, Arial, sans-serif",
            fontWeight: 900,
            fontSize: { xs: 15, sm: 16 },
            textTransform: "none",
            "&:hover": {
              transform: "translateY(-6px) scale(1.05)",
              boxShadow: "0 12px 40px rgba(118,75,162,0.6)",
              background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
              border: "3px solid rgba(255,255,255,0.5)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: -4,
              left: -4,
              right: -4,
              bottom: -4,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: { xs: 32, sm: 30 },
              opacity: 0.3,
              filter: "blur(10px)",
              zIndex: -1,
            },
          }}
          startIcon={
            <Box sx={{ position: "relative" }}>
              <LocalOfferIcon 
                sx={{ 
                  fontSize: { xs: 24, sm: 26 },
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
                }} 
              />
              {/* Sparkle effect */}
              <Box
                sx={{
                  position: "absolute",
                  top: -4,
                  right: -4,
                  width: 10,
                  height: 10,
                  bgcolor: "#ffd700",
                  borderRadius: "50%",
                  animation: "sparkle 2s ease-in-out infinite",
                  boxShadow: "0 0 8px #ffd700",
                }}
              />
            </Box>
          }
         >
          العروض
        </Button>
      </Box>
      )}

      {/* Offers Dialog */}
      <Dialog
        open={offersOpen}
        onClose={() => setOffersOpen(false)}
        fullScreen={useMediaQuery("(max-width:600px)")} 
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            height: { xs: "100%", md: "85vh" },
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1, borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CampaignIcon sx={{ fontSize: 28, color: "#4a00e0" }} />
            <Typography variant="h6" sx={{ fontWeight: 800 }}>العروض</Typography>
          </Box>
          <IconButton onClick={() => setOffersOpen(false)}><CloseIcon /></IconButton>
        </Box>
        <Box sx={{ p: { xs: 1, sm: 2 }, height: { xs: "calc(100% - 64px)", md: "calc(85vh - 64px)" }, overflow: "auto" }}>
          <OnlineOffers />
        </Box>
      </Dialog>

      {/* Footer Image - محسّن للهاتف */}
      <Box
        sx={{
          width: "100%",
          mt: { xs: 2, sm: 3, md: 4 },
          overflow: "hidden",
          borderTop: "2px solid #ffe0b2",
          bgcolor: "#f5f5f5",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={footerImage}
          alt="Footer"
          onError={(e) => {
  e.currentTarget.src = placeholderFooter;
}}
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            maxHeight: { xs: 180, sm: 250, md: 300 },
            objectFit: "contain",
            objectPosition: "center",
            bgcolor: "#f5f5f5",
          }}
        />
      </Box>

      {/* Copyright */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "#fffbe6",
          borderTop: "1px solid #ffe0b2",
          py: { xs: 1.5, sm: 2 },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: "#999",
            fontSize: { xs: 11, sm: 12 },
            fontWeight: 500,
          }}
        >
          جميع الحقوق محفوظة ريستوكاش © {new Date().getFullYear()}
        </Typography>
      </Box>

      {/* Animation for WhatsApp button */}
      <style>
        {`
          @keyframes whatsapp-pulse {
            0% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
            }
            50% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.7), 0 0 0 10px rgba(37, 211, 102, 0.1);
            }
            100% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
            }
          }

          @keyframes offers-pulse {
            0%, 100% {
              box-shadow: 0 8px 30px rgba(118,75,162,0.4);
              transform: scale(1);
            }
            50% {
              box-shadow: 0 8px 40px rgba(118,75,162,0.6), 0 0 0 10px rgba(118,75,162,0.1);
              transform: scale(1.02);
            }
          }

          @keyframes sparkle {
            0%, 100% {
              opacity: 0;
              transform: scale(0.5) rotate(0deg);
            }
            50% {
              opacity: 1;
              transform: scale(1) rotate(180deg);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default CustomerMenu;
